<div class="preloader-wrapper active  {{spinnerType}}">
    <mdb-Spinners mdbSpinners mode="indeterminate"></mdb-Spinners>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/progressbars/progress-spinner.component.html